import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../Assets/logo.svg';
import './Navbar.css';

const Navbar = () => {
    const [toggleBar, setToggleBar] = useState(false);

    return (
        <div className='fixed-top'>
            <div className='container mx-md-5'>
                <div className="navbar-content px-md-5">
                    <a className="logo" href="/home">
                        <img src={logo} alt="" />
                    </a>
                    <ul className={toggleBar ? "navLinksToggle" : "navLinks"}
                        onClick={() => { setToggleBar(false) }}>
                        <Link to="/about" className="link"><li className="lists">About Us</li></Link>
                        <Link to="/ourVision" className="link"><li className="lists"> Our Vision</li></Link>
                        <Link to="/services" className="link"><li className="lists"> Services</li></Link>
                        <Link to="/" className="link"><li className="lists"> Clients</li></Link>
                        <Link to="/" className="link"><li className="lists">Partners</li></Link>
                        <Link to="/" className="link"><li className="lists"> Blogs</li></Link>
                        <Link to="/" className="link"><li className="lists"> Career</li></Link>
                        <Link to="/" className="link"><li className="lists last-child"> Contact us</li></Link>
                    </ul>
                    <button className='toggler-icon'
                        onClick={() => setToggleBar(!toggleBar)}>
                        {toggleBar ? (<i className="fa fa-times"></i>)
                            :
                            (<i className="fa fa-bars"></i>)}
                    </button>
                </div>
            </div>
        </div>
    )
};

export default Navbar;